import React, {useState} from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import TitleLight from '../../components/Text/TitleLight';
import i18n from '../../locales';
import MainStyles from '../../styles/MainStyles';
import './index.css'
import TitleBold from '../../components/Text/TitleBold';
import WhiteButton from '../../components/Buttons/WhiteButton';
import InputText from '../../components/FormComponents/InputText';
import BannerHeader from '../../components/Headers/BannerHeader';
import { getVehicleData } from '../../services/Vehicles'
import { isValidModelYear } from '../../services/utils';
import Loading from '../../components/Loading';
import TextError from '../../components/Text/TextError';
import InputNumber from '../../components/FormComponents/InputNumber';
let { basePath } = require('../../shared/constants');

const resetVinValidation = (setVinValidate, invalidVin, vinValue, isFetching) => {
  setVinValidate({isValid: null, invalidVin: invalidVin, vin: vinValue, mileage: null, isFetching: isFetching});
}

const isFormValid = (vinValidate) => {
 return !vinValidate || (vinValidate && (!vinValidate.isValid || (!vinValidate.mileage || vinValidate.mileage < 0)))
}

const _goToConfirm = (props, vehicleData) => {
  props.history.push({
    pathname: '/vehicle-confirm',
    state: {
      "user": {
        "document": props.location.state.document ? props.location.state.document : props.location.state.user.document,
        "name": props.location.state.name ? props.location.state.name : props.location.state.user.name,
        "phone": ""
      },
      "userVehicle": vehicleData
    }
  })
}

const _checkVin = async (value, setVinValidate) => {
  try {
    resetVinValidation(setVinValidate, null, value, true);
    const responseVIN = await getVehicleData(value)
    if(responseVIN && responseVIN.modelYear) {
      // console.log('validate, ', isValidModelYear(responseVIN.modelYear))
      setVinValidate({
        ...responseVIN,
        isValid: isValidModelYear(responseVIN.modelYear),
        mileage: -1,
        isFetching: false
      });
    } else {
      if(responseVIN.response.status === 500) {
        window.location.href = `${basePath()}/error`
        // if(responseVIN.response.data &&
        //   responseVIN.response.data.body &&
        //   JSON.parse(responseVIN.response.data.body)) {
        //     resetVinValidation(setVinValidate, true);
        // } else {
        //   resetVinValidation(setVinValidate);
        // }
      } else {
        resetVinValidation(setVinValidate);
      }
    }
  } catch (e) {
    resetVinValidation(setVinValidate);
  }
}

const PageVehicleForm = (props) => {
  const [vinValidate, setVinValidate] = useState(null)
  return (
    <div>
      <BannerHeader/>
      <Row className='vehicleform-row' style={{ ...MainStyles.containerGradient }}>
        <Col>
          <Row>
            <Col sm={{ span: 6, offset: 1 }} md={{ span: 5, offset: 1 }}>
              <TitleLight
                text={i18n.t('vehicle_form.hello')}
                size={'medium'}
                color={MainStyles.colors.white}
              />
              <TitleLight
                text={props.location.state ? props.location.state.name : ''}
                size={'medium'}
                color={MainStyles.colors.white}
              />
              <TitleLight
                text={','}
                size={'medium'}
                color={MainStyles.colors.white}
              />
              <br />
              <TitleBold
                text={i18n.t('vehicle_form.title')}
                size={'medium'}
                color={MainStyles.colors.white}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={{ span: 10, offset: 1 }} md={{ span: 7, offset: 2 }}>
              <Form style={{marginTop: '7%'}}>
                <InputText
                  text={i18n.t('vehicle_form.fields.chassi')}
                  controlId={"vin"}
                  required={true}
                  onKeyPress={e =>{
                    if(e.currentTarget.value.length > 15) {
                        _checkVin(e.currentTarget.value + e.key, setVinValidate)
                    }
                  }}
                  inputChangeEnd={e => {
                    if(e.currentTarget.value.length > 15) {
                        _checkVin(e.currentTarget.value, setVinValidate)
                    }
                  }}
                  isUpperCase={true}
                  minLength={16}
                  maxLength={17}
                />

                {/* { (vinValidate && !vinValidate.isValid && !vinValidate.isFetching) &&
                  (vinValidate.vin || vinValidate.invalidVin) &&
                    <TextError
                      text={vinValidate.invalidVin ? i18n.t('general.invalid_vin') : i18n.t('general.validation_2020')}
                      size={'little'}
                    />
                } */}

                <TitleLight
                  text={i18n.t('vehicle_form.fields.chassi_desc')}
                  size={'little'}
                  color={MainStyles.colors.white}
                />
                <InputNumber
                  required={true}
                  labelText={i18n.t('vehicle_form.fields.km')}
                  setValue={(value) => {
                    console.log(value, vinValidate)
                    setVinValidate({
                      ...vinValidate,
                      mileage: value,
                      isFetching: false,
                    })
                  }}
                />
              </Form>
            </Col>
          </Row>
          <Row>
            <Col style={{ textAlign: 'center', marginTop: '5%' }} xs={{ span: 12 }} sm={{ span: 4, offset: 7 }}>
              <WhiteButton
                // isDisabled={isFormValid(vinValidate)}
                text={i18n.t('general.next')}
                isRounded={true}
                onClick={() => {
                  _goToConfirm(props, vinValidate)
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Loading modalShow={vinValidate && vinValidate.isFetching}/>
    </div>
  )
}

export default PageVehicleForm
